import { GET_BENEFIT_GROUP, GET_BENEFIT_GROUP_SUCCESS, GET_BENEFIT_GROUP_ERROR, GET_BENEFIT_GROUP_EMPTY } from './../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBenefitGroup = (state = initialState, action) => {
  switch (action.type) {
    case GET_BENEFIT_GROUP:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BENEFIT_GROUP_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };

      break;

    case GET_BENEFIT_GROUP_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BENEFIT_GROUP_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBenefitGroup;
